// High-level layout for CMS pages.

import {
  type FunctionComponent, type ReactNode, useRef, useState,
} from 'react';

import { useGlobalState } from 'utils';

import IconBell from 'assets/images/icon-bell-24px.svg';

import CmsMenu from '../Menu';
import NotificationsPanel from '../NotificationsPanel';

import './style.scss';

type PropsT = {
  children: ReactNode;
  contentClassName?: string;
  subTitle: string;
  title: string;
};

export const AdminPage: FunctionComponent<PropsT> = ({
  children,
  contentClassName,
  subTitle,
  title,
}) => {
  const [isExpandedRaw] = useGlobalState('ui.adminSidebarExpanded');
  const isExpanded = isExpandedRaw !== false;

  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const bellRef = useRef<HTMLButtonElement>(null);

  return (
    <div styleName={`container ${isExpanded ? 'expanded' : ''}`}>
      <CmsMenu />
      <div styleName="mainArea">
        <div styleName="header">
          <div styleName="titles">
            <h1>{title}</h1>
            <h2>{subTitle}</h2>
          </div>
          <div styleName="notificationsWrap">
            <button
              aria-label="Notifications"
              onClick={() => {
                setNotificationsOpen((prev) => !prev);
              }}
              ref={bellRef}
              styleName="notifications"
              type="button"
            >
              <IconBell />
            </button>
            {notificationsOpen ? (
              <NotificationsPanel
                anchorRef={bellRef}
                onClose={() => {
                  setNotificationsOpen(false);
                }}
              />
            ) : null}
          </div>
        </div>
        <div className={contentClassName} styleName="content">{children}</div>
      </div>
    </div>
  );
};
